import { motion } from 'framer-motion';
import { openBookingModal } from './BookingModal';
import { useLanguage } from '../context/LanguageContext';
import { openLightbox } from './ImageLightbox';

const PRICING_IMG = 'https://customer-assets.emergentagent.com/job_escape-nexus/artifacts/u2ygy2c6_NEW-OKI-ESCAPE-PRICING-RYCOM-pdf.jpg';

export default function PricingSection() {
  const { t } = useLanguage();

  return (
    <section data-testid="pricing-section" className="py-4 sm:py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="bg-card border border-border rounded-3xl overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
            <div className="bg-black flex items-center justify-center p-4 lg:p-8">
              <img src={PRICING_IMG} alt="OKI-ESCAPE Pricing" className="w-full h-auto max-h-[500px] object-contain rounded-xl cursor-zoom-in" onClick={() => openLightbox(PRICING_IMG, 'OKI-ESCAPE Pricing')} />
            </div>
            <div className="p-8 sm:p-10 lg:p-12 flex flex-col justify-center">
              <h3 className="font-heading text-3xl sm:text-4xl tracking-tight uppercase text-foreground mb-6">
                <span className="text-brand">{t('pricing')}</span> {t('pricingPerPerson')}
              </h3>
              <div className="space-y-4">
                <div className="flex items-center justify-between p-4 bg-secondary rounded-2xl">
                  <div><p className="font-heading text-lg uppercase text-foreground">{t('adult')}</p><p className="font-sans text-xs text-muted-foreground">18+</p></div>
                  <p className="font-heading text-2xl text-brand">¥4,500<span className="text-sm text-muted-foreground ml-1">(税込 ¥4,950)</span></p>
                </div>
                <div className="flex items-center justify-between p-4 bg-secondary rounded-2xl">
                  <div><p className="font-heading text-lg uppercase text-foreground">{t('kids')}</p><p className="font-sans text-xs text-muted-foreground">Ages 7-17</p></div>
                  <p className="font-heading text-2xl text-brand">¥2,000<span className="text-sm text-muted-foreground ml-1">(税込 ¥2,200)</span></p>
                </div>
                <div className="flex items-center justify-between p-4 bg-secondary rounded-2xl">
                  <div><p className="font-heading text-lg uppercase text-foreground">{t('toddlers')}</p><p className="font-sans text-xs text-muted-foreground">Ages 0-6</p></div>
                  <p className="font-heading text-2xl text-brand">{t('free')}</p>
                </div>
              </div>
              <div className="mt-6 space-y-2">
                <p className="font-sans text-xs text-muted-foreground">{t('pricingNote')}</p>
                <p className="font-sans text-xs text-brand font-semibold">{t('pricingDiscount')}</p>
              </div>
              <button onClick={openBookingModal} data-testid="pricing-book-btn" className="mt-6 inline-block text-center font-heading tracking-widest uppercase bg-brand text-white px-8 py-3 rounded-full hover:bg-brand-hover transition-colors neon-glow">
                {t('bookNow')}
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
